import React, { useEffect } from "react";
import "./Contact.css"
import { ImMail3 } from 'react-icons/im';
import { BsFillTelephoneFill } from 'react-icons/bs'
import { BsTwitter } from 'react-icons/bs'
import { BsLinkedin } from 'react-icons/bs'
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = () => {

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div id="contact" className="contact_body">
        <div className="heading">
          <div data-aos="fade-up" data-aos-delay="100" className="contact_head1">
            CONTACT ME
          </div>
          <div data-aos="fade-up" data-aos-delay="150" className="contact_head2">
            LET'S GET IN TOUCH
          </div>
        </div>
        <div className="contact_">
            <div data-aos="fade-up" data-aos-delay="300" className="container email">
                <ImMail3 /> rohanpandey749@gmail.com
            </div>
            <div data-aos="fade-up" data-aos-delay="400" className="container phno">
                <BsFillTelephoneFill /> +91-8210036627
            </div>
            <div data-aos="fade-up" data-aos-delay="500" className="container twitter">
                <BsTwitter /> @heyrohan7
            </div>
            <div data-aos="fade-up" data-aos-delay="600" className="container linkdn">
                <BsLinkedin /> Rohan Kumar Pandey 
            </div>
        </div>
        <div className="copyright">&copy; Copyright 2022 Rohan Kumar Pandey</div>
      </div>
    </>
  );
};

export default Contact;
